export default "__VITE_ASSET__Bl59alIM__"